/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */

import anime from "animejs/lib/anime.es.js";
const videos = document.querySelectorAll(
	".sc-video__iframe-container > figure > .wp-block-embed__wrapper",
);

let options = {
	root: null,
	rootMargin: "0px",
	threshold: 0.0,
};
function handleVideoWatcherEntry(entries, observer) {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			animateVideo(entry.target);
			observer.unobserve(entry.target);
		}
	});
}

const intersectionWathcer = () => {
	let observerVideo = new IntersectionObserver(
		handleVideoWatcherEntry,
		options,
	);

	videos.forEach((video) => {
		observerVideo.observe(video);
	});
};

intersectionWathcer();

const animateVideo = (step) => {
	anime({
		targets: step,
		top: "0px",
		opacity: [0, 1],
		easing: "easeOutExpo",
		duration: 500,
		delay: 500,
	});
};

document.addEventListener("DOMContentLoaded", () => {
    const openButtonPay = document.querySelector(".sc-button-animated");
    const closeButtonsPay = document.querySelectorAll(".close-x");
    const popUpOverlayPay = document.querySelector(".popup-overlay-pay");
    const contentModal = document.querySelector(".sc-pay-options__content");

    if (openButtonPay) {
        openButtonPay.classList.remove("sc-two-columns__container__left__button");
        openButtonPay.removeAttribute("href");
    }

    const openPopUpForm = () => {
        if (contentModal && popUpOverlayPay) {
            contentModal.classList.add("show");
            popUpOverlayPay.classList.add("show");
        }
    };

    const closePopUpForm = () => {
        if (popUpOverlayPay) {
            popUpOverlayPay.classList.remove("show");
            contentModal.classList.remove("show");
        }
    };

    if (openButtonPay) {
        openButtonPay.addEventListener("click", openPopUpForm);
    }

    closeButtonsPay.forEach((button) => {
        button.addEventListener("click", closePopUpForm);
    });

    if (popUpOverlayPay) {
        popUpOverlayPay.addEventListener("click", (event) => {
            if (!contentModal.contains(event.target)) {
                closePopUpForm();
            }
        });
    }

    let tabs = document.querySelectorAll(".sc-pay-options__content__tab__name");
    tabs.forEach((tab, index) => {
        if (index === 0) {
            tab.classList.add("default", "active");
        }
        tab.addEventListener("click", () => {
            tabs.forEach((t) => t.classList.remove("active"));
            tab.classList.add("active");
        });
    });

    let tabsContents = document.querySelectorAll(".sc-pay-options__content__tab__body");

    tabsContents.forEach((tabContent, index) => {
        if (index === 0) {
            tabContent.style.display = "flex";
        } else {
            tabContent.style.display = "none";
        }
    });

    if (tabs) {
        tabs.forEach((tab) => {
            tab.addEventListener("click", (event) => {
                event.preventDefault();

                tabsContents.forEach((tabContent) => {
                    let numeroTab = tab.dataset.tab;
                    let numeroContent = tabContent.id;
                    if (numeroContent === "content" + numeroTab) {
                        tabContent.style.display = "flex";
                    } else {
                        tabContent.style.display = "none";
                    }
                });
            });
        });
    }

	const selectOptions = document.querySelector(".sc-pay-options__content__tab__header__options__select");
	// const selectOptions = document.querySelector(".sc-pay-options__content__tab__body__info__options__select");


	// selectOptions.forEach((select) => {
		selectOptions.addEventListener("change",()=>{
			let currentValue = selectOptions.value;
			tabsContents.forEach((tabContent) => {
				if(currentValue === tabContent.id){
					tabContent.style.display = "flex";
				}else{
					tabContent.style.display = "none";
				}

			});
		})

	// });
});

